/* eslint react/no-direct-mutation-state: "off", 'jsx-a11y/alt-text': 'off','no-redeclare': 'off','no-dupe-keys': 'off', 'no-loop-func':'off', eqeqeq: 'off' */
import React,{Component} from "react";
import Workorderlist from "./Workorderlist";
import { connect } from "react-redux";
import CreateWorkOrder from "./_ModalsForms/CreateWorkOrder";
import { Button, Modal } from 'reactstrap';
import { getUserDetailsAfterLogin, getUserPreferencesFromEquipmentSummary } from '../../../action/cultureAction';
import { WorkOrderRolePermission } from '../../../action/authenticateUser';
import { GetWorkOrderBuildingsEquipments, GetWorkOrderBuildings } from "../../../action/workorderAction";

class WorkOrderWrapper extends Component {

    componentWillMount() {
        this.props.getUserPreferencesFromEquipmentSummary()
        this.props.getUserDetailsAfterLogin();
        this.props.WorkOrderRolePermission(24);
        this.props.GetWorkOrderBuildings();
        this.props.GetWorkOrderBuildingsEquipments(0);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {

            var Equipment_Name = '';
            var Equipment_Id = 0;
            var siteId = this.props.EquipmentSummary[0].BuildingID > 0 ? this.props.EquipmentSummary[0].BuildingID : window.top.location.href.split("BuildingId=")[1].split("&")[0];
            var objectId = this.props.EquipmentSummary[0].EquipmentID > 0 ? this.props.EquipmentSummary[0].EquipmentID : window.top.location.href.split("EquipmentId=")[1].split("&")[0];
            var Building = (nextProps.getWorkOrderBuildings != undefined && nextProps.getWorkOrderBuildings.filter(x => x.siteId == siteId && x.isDeleted == false).length > 0) ? nextProps.getWorkOrderBuildings.filter(x => x.siteId == siteId && x.isDeleted == false) : [];
            nextProps.getBuildingEquipments.forEach(building => {
                if (building.equipment != undefined && building.equipment != null && building.equipment.length > 0) {
                    if(building.equipment.filter(x => x.objectId == objectId).length > 0)
                    {
                        Equipment_Name = building.equipment.filter(x => x.objectId == objectId)[0].objectName;
                        Equipment_Id = objectId;
                    }
                }
            });

            var l_BuildingId = Building.length > 0 ? Building[0].id: 0;
            var l_BuildingName = Building.length > 0 ? Building[0].name: '';

            var AlarmLog = []
            var lineItem = {
                "SiteId": l_BuildingId,
                "SiteName": l_BuildingName,
                "EquipmentId": Equipment_Id,
                "EquipmentName": Equipment_Name,
                "Description": ''
            }
            AlarmLog.push(lineItem);

            this.setState({AlarmInfo: AlarmLog});

        //   var modalClose = nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
        //   if (modalClose === "close") {
        //     this.setState({ modal: false });
        //   }
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            AlarmInfo: [],
            IsBtnVisible: true
        };
        this.toggle = this.toggle.bind(this);
        //this.WrapperPopupCancel = this.WrapperPopupCancel.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    HideCreateButton = () =>
    {
        this.setState({
            IsBtnVisible: false
        });
    }

    ShowCreateButton = () =>
    {
        this.setState({
            IsBtnVisible: true
        });
    }
    
    WrapperPopupCancel = (IsSave) =>
    {       
        if(IsSave == 1)
        {
            window.fnClearCheckBoxForWorkorder();
        }
        this.setState({
            modal: false
        });      
    }

    render() {        
        return (
            <div>
                {
                 (this.state.IsBtnVisible && this.props.UserCanEdit == 3) ? <Button type="button" className="btn btn-success  TenantActionBtns workOrderButton" onClick={this.toggle}>Create Work Order</Button> : ""
                }
                <Workorderlist Premise={this.props.OnPremises}  ForEquipment={true} EquipmentSummaryId={this.props.EquipmentSummary[0].EquipmentID > 0 ? this.props.EquipmentSummary[0].EquipmentID : window.top.location.href.split("EquipmentId=")[1].split("&")[0]} HideButton={this.HideCreateButton} ShowCreateButton={this.ShowCreateButton} />
                <Modal zIndex={2147483646} isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} style={{'max-width':'750px !important', 'z-index': '2147483647 !important'}}>
                    <CreateWorkOrder Premise={this.props.OnPremises} ForEquipment={true} AlarmInfo={this.state.AlarmInfo} OnPopupCancel={this.WrapperPopupCancel} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise,
        UserCanEdit: state.authService.HasWorkOrderAccess,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        EquipmentSummary: state.authService.EquipmentSummaryDetail,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUserPreferencesFromEquipmentSummary: () => dispatch(getUserPreferencesFromEquipmentSummary()),
        getUserDetailsAfterLogin: () => dispatch(getUserDetailsAfterLogin()),
        WorkOrderRolePermission: (applicationId) => dispatch(WorkOrderRolePermission(applicationId)),
        //GetStandardFieldsForWrapper: () => dispatch(GetStandardFieldsForWrapper())
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        GetWorkOrderBuildingsEquipments: (BuildingId) => dispatch(GetWorkOrderBuildingsEquipments(BuildingId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderWrapper)

